module.exports = __webpack_public_path__ + "static/img/loginHead.34428df3.png";